/**
 * CustomerChargesTab - Aba de cobranças financeiras no modal do cliente
 * Lista todas as cobranças vinculadas ao customer_id usando RPC paginada
 * 
 * @version 3.0.0
 * RELEASE: 2026-03-16 v3.0.0 - Migrado para RPC get_cobrancas_paginated (unificação)
 * RELEASE: 2026-03-15 v2.0.0 - Refatorado para layout de tabela unificado
 * RELEASE: 2026-03-14 v1.0.0 - Criação da aba (Etapa 2)
 */
import React from 'react';
import { useFinanceiroCobrancasPaginated } from '@/hooks/useFinanceiroCobrancasPaginated';
import { ChargesTableView } from '@/components/financial/ChargesTableView';

/** Props do componente */
interface CustomerChargesTabProps {
  /** ID do cliente */
  customerId: string;
  /** Se a aba está ativa (lazy loading) */
  isActive?: boolean;
  /** v3.1.0: Permissão para editar cobrança (financial_charges.can_edit) */
  canEdit?: boolean;
  /** v3.1.0: Permissão para excluir/cancelar cobrança (financial_charges.can_delete) */
  canDelete?: boolean;
}

/**
 * Aba de cobranças dentro do modal premium de cliente
 * Usa RPC get_cobrancas_paginated com filtro customer_id (fonte de dados unificada)
 */
export function CustomerChargesTab({
  customerId,
  isActive = false,
  canEdit = true,
  canDelete = true,
}: CustomerChargesTabProps) {
  // Busca cobranças do cliente via RPC paginada (pageSize grande para listar todas)
  const { cobrancas, isLoading } = useFinanceiroCobrancasPaginated(
    isActive ? { customer_id: customerId } : undefined,
    { page: 1, pageSize: 200 }
  );

  return (
    <ChargesTableView
      charges={cobrancas}
      isLoading={isLoading}
      emptyMessage="Nenhuma cobrança encontrada para este cliente"
      canEdit={canEdit}
      canDelete={canDelete}
    />
  );
}
